<template>
  <div class="class-list">
    <GlobalInfoBar
      title="分润账单"
      content="统计拓展客户的成交订单的抽成数据，每单按订单成交自动扣除，退款则自动返回。统计数据按选择的查询时间段自动统计"
    />
    <!-- <Info/> -->
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <From />
      </div>
      <Table />
    </GlobalChunk>
  </div>
</template>

<script>
import From from "./Form";
import Table from "./Table";
export default {
  name: "class-list",
  components: {
    From,
    Table
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
</style>